// extracted by extract-css-chunks-webpack-plugin
module.exports = {"ProgressiveImage":"ProgressiveImage","ProgressiveImage__image":"ProgressiveImage__image","ProgressiveImage__image--loaded":"ProgressiveImage__image--loaded"};